import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {useEffect, useState} from 'react'
import {QUERY_KEYS} from '@/queryClient'
import {httpGetMailBatches, HttpGetMailBatchesParams, MailBatchListResponse} from '@/features/mailer/http/mailer.http'
import {PaginationResponse} from '@/types'

export const useMailBatches = (
    params: HttpGetMailBatchesParams,
    options?: Omit<UseQueryOptions<MailBatchListResponse>, 'queryKey' | 'queryFn'>
) => {
    const [persistedPagination, setPersistedPagination] = useState<PaginationResponse>({
        total: 0,
        lastPage: 1,
        perPage: params.limit,
        currentPage: params.page
    })

    const query = useQuery({
        queryKey: [QUERY_KEYS.MAILER_BATCHES, params],
        queryFn: () => httpGetMailBatches(params),
        ...options
    })

    useEffect(() => {
        if (query.isSuccess) {
            setPersistedPagination(query.data.meta)
        }
    }, [query.data?.data.length])

    return {...query, persistedPagination}
}
